// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import './common/font/font.css';
import './common/font/iconfont.css';
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import ElementUI from 'element-ui';
import Echarts from "echarts";



import bmap  from 'echarts/extension/bmap/bmap.js'
Echarts.registerMap('bmap', bmap)


import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/css/navTabs.css";
import "@/assets/css/aboutUs.css";
import "@/assets/css/home.css";
import "@/assets/css/register.css";
import "@/assets/css/shipSchedule.css";
import "@/assets/css/account.css";
import '@/assets/css/order.css';
import '@/assets/css/Logist.css';
import '@/assets/css/orderTwo.css';
import '@/assets/css/bill.css';
import '@/assets/css/forgetPassword.css';
import { apiService } from './request'


Vue.prototype.echarts = Echarts;
Vue.use(Echarts);

Vue.prototype.apiUrl = process.env[process.env.ACTIVE_ENV_CONFIG].API_PATH
Vue.prototype.apiService = apiService
Vue.config.productionTip = false
Vue.prototype.$message;
Vue.prototype.$msgbox;
Vue.prototype.axios = axios;
Vue.prototype.$cookies = VueCookies;
// Vue.prototype.apiUrl = process.env.NODE_ENV === "production" ? 'http://106.14.140.103:82' : '/apis';//全局的url地址\
//http://106.15.56.14:82 正式
// axios.defaults.baseURL='http://106.14.140.103:82';
Vue.use(ElementUI)
// Vue.use(ElementUI, ElRow, ElCol, ElMain, ElIcon,
//   ElImage, ElButton, ElFooter, ElDialog, ElForm, ElFormItem, ElInput);
//进入路由之前设置title
var _hmt = window._hmt || []
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //判断用户是否登录
    if (!VueCookies.get('username') && !VueCookies.get('password')) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      if (to.path) {
        _hmt.push(['_trackPageview', '/#' + to.path])
      }
    } else {
      if (to.path) {
        _hmt.push(['_trackPageview', '/#' + to.path])
      }
      next()
    }
  } else {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.path])
    }
    next() // 确保一定要调用 next()
  }
  let title = to.meta.title
  if (to.meta.title) {
    window.document.title = title;
  } else {
    window.document.title = 'Eimskip';
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js